export default __webpack_public_path__ + "static/media/banner_1_iphone.bf93bdc7.png";